





































import Vue from 'vue'
import { ButtonLink } from '@raksul/raksul-common-ui'
import ModalOverlay from '@/common/components/ModalOverlay.vue'
import { getJsonData } from '@/common/utils/dom'

type AppSettings = {
  authUrl: string
  coreUrl: string
}

export default Vue.extend({
  components: {
    ModalOverlay,
    ButtonLink
  },
  data(): {
    appSettings: AppSettings
    redirectUrl: string
  } {
    return {
      appSettings: getJsonData('#json_app_setting'),
      redirectUrl: encodeURIComponent(window.location.href)
    }
  },
  computed: {
    loginUrl(): string {
      return `${this.appSettings.authUrl}?path=${this.redirectUrl}`
    },
    registerUrl(): string {
      return `${this.appSettings.coreUrl}/account/register/new?path=${this.redirectUrl}`
    }
  }
})
